module.exports = __webpack_public_path__ + "img/burned-candle.8c4c84ff.png";